import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function PriorityPanel({ priorityData, priorityColorMap, onMetricClick }) {
  const theme = useTheme();

  const styles = {
    panel: {
      bgcolor: "background.cardBackground",
      border: 1,
      borderColor: "background.tableHeader",
      borderRadius: 2,
      p: 2.5,
    },
    title: {
      fontSize: "0.75rem",
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      fontWeight: 700,
      color: "background.textMuted",
      mb: 2,
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 1,
    },
    card: (color, count) => ({
      border: 2,
      borderColor: `color-mix(in srgb, ${color} 40%, transparent)`,
      bgcolor: `color-mix(in srgb, ${color} 4%, transparent)`,
      borderRadius: 1.5,
      p: 1.75,
      minWidth: 0,
      overflow: "hidden",
      ...(count > 0 && {
        cursor: "pointer",
        transition: "box-shadow 0.15s",
        "&:hover": {
          boxShadow: 4,
          borderColor: `color-mix(in srgb, ${color} 80%, transparent)`,
        },
      }),
    }),
    cardLabel: (color) => ({
      fontSize: "0.75rem",
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      fontWeight: 700,
      mb: 0.75,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      color,
    }),
    cardCount: (color) => ({
      fontSize: "2rem",
      fontWeight: 700,
      lineHeight: 1,
      fontVariantNumeric: "tabular-nums",
      color,
    }),
    cardSub: {
      fontSize: "0.75rem",
      color: "background.textMuted",
      mt: 0.375,
    },
  };

  return (
    <Box sx={styles.panel}>
      <Typography sx={styles.title}>By Priority</Typography>
      <Box sx={styles.grid}>
        {priorityData.map(({ priority, count }) => {
          const color = priorityColorMap[priority] || theme.palette.primary.main;
          return (
            <Box
              key={priority}
              sx={styles.card(color, count)}
              onClick={count > 0 ? () => onMetricClick("priority", priority) : undefined}
            >
              <Typography sx={styles.cardLabel(color)}>{priority}</Typography>
              <Typography sx={styles.cardCount(color)}>{count}</Typography>
              <Typography sx={styles.cardSub}>initiatives</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
